import React, { useEffect } from "react";

import LoginForm from "../../account/components/LoginForm";
import { getRequest } from "../../api/axiosRequests";

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import RegistrationHeader from "../components/RegistrationHeader";
import { useAuth } from "../../auth/hook";
import ContainerResponsive from "../../common/components/ContainerResponsive";

export default function Login() {
  const [USER, ADMIN, NONE] = ["User", "Admin", "None"];
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [logged, setLogged] = useState(NONE);
  const auth = useAuth();
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = {
      email: email,
      password: password,
    };
    auth.loginAction(data);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (auth.token === null || auth.token === "" || auth.token === undefined) {
      setLogged(NONE);
      return;
    }
    const headers = { Authorization: auth.token };
    const promiseUser = getRequest("userData/", headers);

    promiseUser
      .then((res) => {
        const user = res.data["data"];
        const role = res.data["role"];

        // setUser(user)
        if (role === "User") {
          setLogged(USER);
        } else if (role === "Admin") {
          setLogged(ADMIN);
        } else {
          setLogged(NONE);
        }
      })
      .catch((errs) => {
        console.log(errs);
        if (errs.response) {
          setLogged(NONE);
        }
      });
  }, []);

  return (
    <>
      {(logged === USER || logged === ADMIN) && navigate("/account/Profile")}
      {logged === NONE && (
        <>
          <RegistrationHeader />
          <ContainerResponsive>
            <LoginForm
              handleSubmit={handleSubmit}
              email={email}
              password={password}
              setEmail={setEmail}
              setPassword={setPassword}
              error={error}
            />
          </ContainerResponsive>
        </>
      )}
    </>
  );
}
